import React from 'react';
import { Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { Icons, ModalSidebar } from 'shared';

export interface SeavProtocolModalPayload {
  data?: null;
  type: ModalType.SEAV;
  isOpen?: boolean;
}

export const SeavProtocolModal = React.forwardRef<
  HTMLElement,
  Pick<SeavProtocolModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose, isOpen }, ref) => {
  return (
    <ModalSidebar
      isOpen={isOpen}
      ref={ref}
      onClose={onClose}
      title={
        <>
          SEAV Protocol <br />
          (Self-Earning Asset Vault)
        </>
      }
      subtitle="Let Your Crypto Work for You"
      icon={<Icons.SeavProtocolDark />}
      link={{
        title: 'Earn Daily Royalties',
        link: {
          href: 'https://cratd2csmartchain.io',
          text: 'https://cratd2csmartchain.io',
        },
      }}
    >
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        The SEAV Protocol is like a smart digital vault for your $CRAT.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        You can deposit $CRAT, and instead of just sitting there, it earns daily royalties and rewards from ecosystem
        activity.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        You can even borrow against your $CRAT without selling it, so your assets keep working while you access
        liquidity.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        In simple terms: save, earn, and borrow - all in one DeFi vault.
      </Typography>
    </ModalSidebar>
  );
});
